import { IoAlert } from "react-icons/io5";
import { Spin } from "antd";

import classes from './AccountBlocked.module.scss'

import ContainerWithIconHeader from "../ContainerWithIconHeader/ContainerWithIconHeader"
import CountdownTimer from "../CountdownTimer/CountdownTimer";

const AccountBlocked = ({banExpirationTime, onExpireHandler}) => {
    return <ContainerWithIconHeader
        color="#f44336"
        icon={<IoAlert size={45} />}
        title="Лимит превышен.">
        <div className={classes.container}>
            <div className="AccountBlocked_text_color">Вы превысили лимит попыток ввода. Функционал будет доступен через:</div>
            <div className={classes.banExpirationTimeContainer}>
                {
                    !banExpirationTime
                        ? <Spin />
                        : <CountdownTimer withLabels targetDate={banExpirationTime} onExpireHandler={onExpireHandler} />
                }
            </div>
        </div>
    </ContainerWithIconHeader>
}

export default AccountBlocked